import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'

export default function Settings() {
  const [team, setTeam] = useState<any>(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => { fetchTeam() }, [])

  const fetchTeam = async () => {
    const { data } = await supabase.from('teams').select('*').single()
    if (data) setTeam(data)
  }

  const save = async () => {
    if (!team) return
    setLoading(true)
    await supabase.from('teams').update({
      name: team.name, primary_phone: team.primary_phone,
      primary_email: team.primary_email, brand_color: team.brand_color
    }).eq('id', team.id)
    setLoading(false)
  }

  if (!team) return <div>Loading...</div>

  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Settings</h1>
      <div className="bg-white rounded-lg shadow p-6 max-w-2xl space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Team Name</label>
          <input type="text" value={team.name} onChange={(e) => setTeam({...team, name: e.target.value})} className="w-full px-3 py-2 border rounded-md" />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Phone</label>
          <input type="tel" value={team.primary_phone || ''} onChange={(e) => setTeam({...team, primary_phone: e.target.value})} className="w-full px-3 py-2 border rounded-md" />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
          <input type="email" value={team.primary_email || ''} onChange={(e) => setTeam({...team, primary_email: e.target.value})} className="w-full px-3 py-2 border rounded-md" />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Brand Color</label>
          <div className="flex gap-2">
            <input type="color" value={team.brand_color || '#1E5FD9'} onChange={(e) => setTeam({...team, brand_color: e.target.value})} className="w-12 h-10 rounded" />
            <input type="text" value={team.brand_color || '#1E5FD9'} onChange={(e) => setTeam({...team, brand_color: e.target.value})} className="flex-1 px-3 py-2 border rounded-md" />
          </div>
        </div>
        <button onClick={save} disabled={loading} className="px-6 py-2 bg-primary text-white rounded-lg disabled:opacity-50">
          {loading ? 'Saving...' : 'Save'}
        </button>
      </div>
    </div>
  )
}
